module.exports = __webpack_public_path__ + "static/media/GearedSlab-Regular.3bfc8351.ttf";